/**
 * Dataset limits and warning thresholds
 * Single source of truth for large dataset warnings
 */

// Threshold for showing warning dialog when switching to BY LEASE view
export const LEASE_VIEW_WARNING_THRESHOLD = 500;

// Recommended limit mentioned in warning message
export const LEASE_VIEW_RECOMMENDED_LIMIT = 500;

// Warning dialog title
export const LEASE_VIEW_WARNING_TITLE = 'Large Dataset Warning';

// Warning dialog message
export const LEASE_VIEW_WARNING_MESSAGE = `This view may take a while to load or might not function properly due to the large number of leases. It is recommended to reduce the number of leases in search results to ${LEASE_VIEW_RECOMMENDED_LIMIT.toLocaleString()} or less.`;

